import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type IStandardsState from './interfaces/IStandardsState';

export const initialState: IStandardsState = {
  loading: false,
};

export const standardsSlice = createSlice({
  name: 'standards',
  initialState,
  reducers: {
    setLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.loading = payload;
    },
    resetState: () => initialState,
  },
});

export const { setLoading, resetState } = standardsSlice.actions;

export default standardsSlice.reducer;
